import {
  Text,
  Popover,
  Switch,
  GreyGrey20,
  GreyGrey60,
  Primary13Regular,
  Primary13SemiBold,
  IconCircleQuestionmark,
  Box,
  Flex
} from '@sequencehq/core-components'

type IntegrationActiveToggleProps = {
  /** Whether the switch is on (reflects the pending/edited value). */
  checked: boolean
  /** Whether the integration is currently active (reflects the saved value). */
  active: boolean
  onChange: (checked: boolean) => void
}

/**
 * The integration on/off (pause) control shared by the ERP settings pages.
 * Pausing preserves the settings underneath. `checked` drives the switch and
 * `active` the label, so an unsaved toggle shows the new switch position while
 * the label still reflects the saved state (matching the save-on-submit pages).
 */
export const IntegrationActiveToggle = ({
  checked,
  active,
  onChange
}: IntegrationActiveToggleProps) => (
  <Box
    width="100%"
    p={4}
    bgColor={GreyGrey20}
    as={Flex}
    gap={2}
    borderRadius="8px"
    alignItems="center"
  >
    <Switch
      data-testid="switch.importCustomerWorkflow"
      checked={checked}
      onChange={onChange}
    />
    <Flex gap={1} alignItems="center">
      <Text {...Primary13Regular}>
        Connector is{' '}
        <Text as="span" {...Primary13SemiBold}>
          {active ? 'active' : 'inactive'}
        </Text>
      </Text>
      <Popover
        header="Pausing connectors"
        content="Some connectors can be paused temporarily if needed. When paused, your settings will be saved."
        position="top"
      >
        <IconCircleQuestionmark color={GreyGrey60} />
      </Popover>
    </Flex>
  </Box>
)
